import React from 'react';
import { Check } from 'lucide-react';
import { pricingTiers } from '../mock';
import { Button } from './ui/button';

const Pricing = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-20 bg-black relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-orange-950/10 to-transparent"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
          <span className="bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
            Pricing Packages
          </span>
        </h2>

        <div className="space-y-16">
          {pricingTiers.map((tier) => (
            <div key={tier.id}>
              <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-white">
                {tier.category}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {tier.packages.map((pkg, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-br from-gray-900 to-black border border-orange-500/30 rounded-xl p-8 hover:border-orange-500 transition-all duration-300 hover:shadow-2xl hover:shadow-orange-500/20 hover:-translate-y-2 group"
                  >
                    {/* Duration Badge */}
                    <div className="inline-block bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-2 rounded-full font-bold text-lg mb-4">
                      {pkg.duration}
                    </div>

                    {/* Price */}
                    <div className="mb-6">
                      <p className="text-5xl font-bold text-white group-hover:text-orange-400 transition-colors">
                        {pkg.price}
                      </p>
                    </div>

                    {/* Features */}
                    <ul className="space-y-3 mb-8">
                      {pkg.features.map((feature, fIndex) => (
                        <li key={fIndex} className="flex items-start gap-2">
                          <Check className="h-5 w-5 text-orange-500 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-300 text-sm">{feature}</span>
                        </li>
                      ))}
                    </ul>

                    {/* CTA Button */}
                    <Button
                      onClick={scrollToContact}
                      className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold py-3 rounded-lg transition-all hover:shadow-lg hover:shadow-orange-500/50"
                    >
                      Order Now
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;